import type { HealthState } from "../types";

const LABELS: Record<HealthState, string> = {
  normal: "Online",
  degraded: "Degraded",
  offline: "Offline",
};

export function HealthBadge({ state }: { state: HealthState }) {
  const cls = state === "normal" ? "badge-normal" : state === "degraded" ? "badge-degraded" : "badge-offline";
  return (
    <span className={`badge ${cls}`}>
      <span className="badge-dot" />
      {LABELS[state]}
    </span>
  );
}
